export const eventSample = [
    {
      "Priority": "3.0",
      "Notification_key": "00008",
      "Status": "INI",
      "Shift_resp_area_key": "",
      "Done": "No",
      "Notification_type_key": "",
      "Position_key": "MEDP",
      "Maint_object_key": "",
      "Reported_by": "SUPERVISOR",
      "Order_date_time": "2019-12-16 16:00:00",
      "Responsible": "",
      "Work_order_key": "",
      "Work_order_status": "",
      "Notification_name": "Wolk around the Process Area",
      "Shift_ID": "2.0",
      "Extra_notification_info": "",
      "Document": "No",
      "Site": "",
      "Legal_unit_key": "USD",
      "Currency": "USD",
      "Plant_key": "EURO",
      "sour": ""
    },
    {
      "Priority": "3.0",
      "Notification_key": "00007",
      "Status": "AWO",
      "Shift_resp_area_key": "",
      "Done": "Yes",
      "Notification_type_key": "",
      "Position_key": "PF3100-02",
      "Maint_object_key": "65748-C",
      "Reported_by": "SUPERVISOR",
      "Order_date_time": "2019-12-16 15:35:00",
      "Responsible": "",
      "Work_order_key": "588.0",
      "Work_order_status": "LAT Looked at",
      "Notification_name": "Oil Leaking from the Hydraulic resevoir to somewhere",
      "Shift_ID": "2.0",
      "Extra_notification_info": "",
      "Document": "No",
      "Site": "",
      "Legal_unit_key": "USD",
      "Currency": "USD",
      "Plant_key": "EURO",
      "sour": ""
    },
    {
      "Priority": "3.0",
      "Notification_key": "00006",
      "Status": "CLO",
      "Shift_resp_area_key": "",
      "Done": "Yes",
      "Notification_type_key": "",
      "Position_key": "PF3100-01",
      "Maint_object_key": "34563-Z",
      "Reported_by": "SUPERVISOR",
      "Order_date_time": "2019-12-16 15:30:00",
      "Responsible": "",
      "Work_order_key": "",
      "Work_order_status": "",
      "Notification_name": "Water Stagnant",
      "Shift_ID": "2.0",
      "Extra_notification_info": "",
      "Document": "No",
      "Site": "",
      "Legal_unit_key": "USD",
      "Currency": "USD",
      "Plant_key": "EURO",
      "sour": ""
    },
    {
      "Priority": "3.0",
      "Notification_key": "00005",
      "Status": "CLO",
      "Shift_resp_area_key": "",
      "Done": "Yes",
      "Notification_type_key": "",
      "Position_key": "PF3100-02",
      "Maint_object_key": "65748-C",
      "Reported_by": "SUPERVISOR",
      "Order_date_time": "2019-12-16 15:20:00",
      "Responsible": "",
      "Work_order_key": "584.0",
      "Work_order_status": "LAT Looked at",
      "Notification_name": "Noise in the Hydraulic pump",
      "Shift_ID": "2.0",
      "Extra_notification_info": "",
      "Document": "No",
      "Site": "",
      "Legal_unit_key": "USD",
      "Currency": "USD",
      "Plant_key": "EURO",
      "sour": ""
    },
    {
      "Priority": "3.0",
      "Notification_key": "00004",
      "Status": "CLO",
      "Shift_resp_area_key": "",
      "Done": "Yes",
      "Notification_type_key": "",
      "Position_key": "PF3200-03",
      "Maint_object_key": "12345-A",
      "Reported_by": "SUPERVISOR",
      "Order_date_time": "2019-12-16 15:15:00",
      "Responsible": "",
      "Work_order_key": "583.0",
      "Work_order_status": "LAT Looked at",
      "Notification_name": "Abnormal temperature rise in Hydraulic system",
      "Shift_ID": "2.0",
      "Extra_notification_info": "",
      "Document": "No",
      "Site": "",
      "Legal_unit_key": "USD",
      "Currency": "USD",
      "Plant_key": "EURO",
      "sour": ""
    },
    {
      "Priority": "3.0",
      "Notification_key": "00003",
      "Status": "AWO",
      "Shift_resp_area_key": "",
      "Done": "Yes",
      "Notification_type_key": "",
      "Position_key": "PF3200-02",
      "Maint_object_key": "23456-B",
      "Reported_by": "SUPERVISOR",
      "Order_date_time": "2019-12-16 15:10:00",
      "Responsible": "",
      "Work_order_key": "582.0",
      "Work_order_status": "LAT Looked at",
      "Notification_name": "Unusual vibration in the motor",
      "Shift_ID": "2.0",
      "Extra_notification_info": "",
      "Document": "No",
      "Site": "",
      "Legal_unit_key": "USD",
      "Currency": "USD",
      "Plant_key": "EURO",
      "sour": ""
    },
    {
      "Priority": "3.0",
      "Notification_key": "00002",
      "Status": "CLO",
      "Shift_resp_area_key": "",
      "Done": "Yes",
      "Notification_type_key": "",
      "Position_key": "PF3200-01",
      "Maint_object_key": "34567-C",
      "Reported_by": "SUPERVISOR",
      "Order_date_time": "2019-12-16 15:05:00",
      "Responsible": "",
      "Work_order_key": "581.0",
      "Work_order_status": "LAT Looked at",
      "Notification_name": "Oil leakage at motor bearing",
      "Shift_ID": "2.0",
      "Extra_notification_info": "",
      "Document": "No",
      "Site": "",
      "Legal_unit_key": "USD",
      "Currency": "USD",
      "Plant_key": "EURO",
      "sour": ""
    },
    {
      "Priority": "3.0",
      "Notification_key": "00001",
      "Status": "CLO",
      "Shift_resp_area_key": "",
      "Done": "Yes",
      "Notification_type_key": "",
      "Position_key": "PF3300-01",
      "Maint_object_key": "45678-D",
      "Reported_by": "SUPERVISOR",
      "Order_date_time": "2019-12-16 15:00:00",
      "Responsible": "",
      "Work_order_key": "580.0",
      "Work_order_status": "LAT Looked at",
      "Notification_name": "Abnormal sound in the fan",
      "Shift_ID": "2.0",
      "Extra_notification_info": "",
      "Document": "No",
      "Site": "",
      "Legal_unit_key": "USD",
      "Currency": "USD",
      "Plant_key": "EURO",
      "sour": ""
    }
  ];
  